/*
 * Help center search: an autocomplete dropdown on the "Ko ieškai?" field.
 *
 * Empty and focused, it offers the most-asked questions. As you type it filters, bolds the
 * matched run in each title, and shows each result's place in the help center underneath
 * ("Pagalbos centras > Prekės > OmniSit Pro"), so a title like "Techniniai duomenys |
 * OMNISIT PRO" is not the only thing telling one result from another.
 *
 * Deliberately NOT Shopify search: sections/ergonix-search.liquid gates the price on
 * item.object_type but not the image, so every imageless help article renders as an
 * identical grey placeholder tile.
 *
 * The index is emitted by sections/ergonix-pagalba-index.liquid from the blog itself, so
 * adding an article cannot leave it stale. Copy stays in locale keys, read off data-*
 * attributes, so this file carries no Lithuanian.
 *
 * Matching: diacritic-folded on both sides, prefix match on word starts, minimum 2
 * characters, title hits above summary hits, capped at 8.
 */
(function () {
  'use strict';

  var root = document.getElementById('pagalba-search');
  var input = document.getElementById('pagalba-q');
  var dd = document.getElementById('pagalba-dd');
  var clear = document.getElementById('pagalba-clear');
  var status = document.getElementById('pagalba-status');
  var indexEl = document.getElementById('pagalba-search-index');

  if (!root || !input || !dd || !clear || !status || !indexEl) return;

  var articles;
  try {
    articles = JSON.parse(indexEl.textContent);
  } catch (e) {
    return; // Leave the server-rendered index in place rather than breaking the page.
  }
  if (!Array.isArray(articles) || !articles.length) return;

  var MIN_QUERY = 2;
  var MAX_RESULTS = 8;
  var cursor = -1;
  var rows = [];

  function t(key) {
    return input.getAttribute('data-' + key) || '';
  }

  // Fold diacritics so "grazinimas" finds "grąžinimas". Applied to both sides.
  function fold(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  var haystack = articles.map(function (a) {
    return { t: a.t, u: a.u, c: a.c, p: a.p, ft: fold(a.t), fb: fold(a.b) };
  });

  // Prefix match on any word start, which suits Lithuanian inflection better than
  // substring matching on the whole string.
  function hits(field, q) {
    return field.indexOf(q) === 0 || field.indexOf(' ' + q) !== -1;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  // Bold the matched run in the ORIGINAL title, located via the folded copy, so the
  // highlight lands correctly on words carrying Lithuanian diacritics.
  function highlight(title, needle) {
    if (!needle) return esc(title);
    var i = fold(title).indexOf(needle);
    if (i === -1) return esc(title);
    return esc(title.slice(0, i)) +
      '<mark>' + esc(title.slice(i, i + needle.length)) + '</mark>' +
      esc(title.slice(i + needle.length));
  }

  // Pick the plural form by the LANGUAGE THE PAGE IS IN, not by Lithuanian rules.
  //
  // This used to hardcode Lithuanian (1 rezultatas / 2-9 rezultatai / rest rezultatu).
  // That is right for lt and wrong for every other market the theme serves: Estonian
  // puts everything except 1 in the partitive, so 21 must read "21 tulemust", while the
  // Lithuanian branch picks 'one' for 21 and would render "21 tulemus". Latvian differs
  // again. Intl.PluralRules knows all of them and ships in every browser this store
  // supports; the CLDR category it returns is mapped onto the three keys the locale
  // files carry, with 'other' and 'zero' falling back to count_many.
  function countLabel(n) {
    var form = 'many';
    try {
      var lang = (document.documentElement.getAttribute('lang') || 'lt').trim();
      var cat = new Intl.PluralRules(lang).select(n);
      if (cat === 'one' || cat === 'few' || cat === 'many') form = cat;
    } catch (e) {
      /* No Intl.PluralRules, or a lang tag it cannot parse: count_many is the safe
         default because it is the form these locales use for most numbers. */
    }
    return t('count-' + form).replace('%s', n);
  }

  function render(list, needle, heading) {
    rows = list;
    cursor = -1;

    if (!list.length) {
      dd.innerHTML = '<div class="pagalba-dd-empty">' + esc(t('empty')) + '</div>';
    } else {
      dd.innerHTML =
        (heading ? '<div class="pagalba-dd-head">' + esc(heading) + '</div>' : '') +
        list.map(function (a, i) {
          return '<a class="pagalba-dd-item" role="option" id="pagalba-dd-' + i + '"' +
            ' aria-selected="false" href="' + esc(a.u) + '">' +
            '<span class="pagalba-dd-title">' + highlight(a.t, needle) + '</span>' +
            '<span class="pagalba-dd-crumb">' + esc(a.c) + '</span></a>';
        }).join('');
    }

    dd.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function close() {
    dd.hidden = true;
    dd.innerHTML = '';
    cursor = -1;
    rows = [];
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
  }

  function suggest() {
    var raw = input.value.trim();
    clear.hidden = !raw;

    if (raw.length < MIN_QUERY) {
      var popular = haystack.filter(function (a) { return a.p; });
      if (popular.length) render(popular, '', t('popular-label'));
      else close();
      status.textContent = '';
      return;
    }

    var q = fold(raw);
    var titleHits = [];
    var bodyHits = [];

    haystack.forEach(function (a) {
      if (hits(a.ft, q)) titleHits.push(a);
      else if (hits(a.fb, q)) bodyHits.push(a);
    });

    var matches = titleHits.concat(bodyHits).slice(0, MAX_RESULTS);
    render(matches, q, null);
    status.textContent = matches.length
      ? countLabel(matches.length)
      : t('none').replace('%s', raw);
  }

  function move(step) {
    if (dd.hidden || !rows.length) return;
    var items = dd.querySelectorAll('.pagalba-dd-item');
    if (!items.length) return;
    if (cursor > -1) {
      items[cursor].classList.remove('is-active');
      items[cursor].setAttribute('aria-selected', 'false');
    }
    cursor = (cursor + step + items.length) % items.length;
    items[cursor].classList.add('is-active');
    items[cursor].setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', items[cursor].id);
    items[cursor].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('input', suggest);
  input.addEventListener('focus', suggest);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      move(1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      move(-1);
    } else if (e.key === 'Enter' && cursor > -1) {
      e.preventDefault();
      window.location.href = rows[cursor].u;
    } else if (e.key === 'Escape') {
      input.value = '';
      clear.hidden = true;
      close();
    }
  });

  clear.addEventListener('click', function () {
    input.value = '';
    clear.hidden = true;
    input.focus();
    suggest();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#pagalba-search')) close();
  });
})();
